import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UserApiService } from 'src/app/services/api/user.api.service';
import { CompanyApiService } from 'src/app/services/api/companies.api.service';
import { Company } from 'src/app/classes/Company.class';
import { User } from 'src/app/classes/User.class';

@Component({
  selector: 'company-list-screen',
  templateUrl: './company-list.screen.html',
  styleUrls: ['./company-list.screen.scss'],
})
export class CompanyListScreenComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<string>;
  displayedColumns: string[];
  companies: Company[];
  searchTerm: string;
  user: User;
  userRole: boolean;
  disableDetailButton = false;

  constructor(
    private userApiService: UserApiService,
    private companyApiService: CompanyApiService,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.user = await this.userApiService.getAdmin();
    this.userRole = this.user.role === 'mowa_admin';

    const companies = await this.companyApiService.getCompanies();
    this.displayedColumns = ['mowaId', 'name', 'email', 'city', 'details'];
    this.dataSource = new MatTableDataSource<string>(companies.data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = (data, filter) => {
      return (
        data['mowaId'].toLowerCase().trim().indexOf(filter) !== -1 ||
        JSON.stringify(data['name']).toLowerCase().trim().indexOf(filter) !== -1 ||
        JSON.stringify(data['email']).trim().toLowerCase().indexOf(filter) !== -1
      );
    };
  }

  checkSyncStatus(element: Company) {
    if (!element.mowaId) {
      return true;
    }
  }

  viewCompany(companyId: number) {
    this.router.navigateByUrl(`companies/${companyId}`);
  }

  filterResults() {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  newCompany() {
    this.router.navigateByUrl('/companies/null/edit');
  }
}
